// TextArea.js
import React, {useContext, useState} from 'react';
import DocumentAuthorContext from '../../../../../context/DocumentAuthorContext';

function TextArea({ component }) {
    const [inputValue,setInputValue] = useState(component?.value);
    const { componentAnswers } = useContext(DocumentAuthorContext);

    return (
        <div className={`${component?.label?.alignment === 'top' ? 'flex flex-col' : component?.label?.alignment === 'right' ? 'flex flex-row-reverse' :
            component?.label?.alignment === 'bottom' ? 'flex flex-col-reverse text-center mt-1' : 'flex items-center'} cursor-default`}>
            {component.label.name && <label className={`cursor-default pr-2 break-all`} style={component?.label?.styles}>
                {component.label.name || ''} {component.is_required && <span data-testid="is_required" className='text-[#333]'>*</span>}
            </label>}
            <textarea
                rows={component?.rows}
                maxLength={component?.properties?.maxLength || ''}
                className={`resize-none border border-[#ccc] textbox-lines row-lines ${component.label.alignment === 'top' ? 'mt-2' : '' } forms-authoring-textarea cursor-default`}
                id={component?.id}
                value={inputValue || componentAnswers[component.component_id]}
                style={component?.styles}
                placeholder={component.placeholder.name}
            />
        </div>
    );
}

export default TextArea;